import React from 'react'
import {
  shape, string, func, bool, number,
} from 'prop-types'
import numeral from 'numeral'

import Icon from '../../Icon/Icon'

function MessageImage({
  image, iconName = 'download', onImageClick, index, download = false,
}) {
  function clickHandler(e) {
    e.preventDefault()

    if (download) {
      onImageClick(index)
    } else {
      onImageClick(image.attributes.fileName)
    }
  }

  function downloadBlob(url) {
    axios.get(url, { responseType: 'blob' })
      .then((res) => {
        if (res && res.data) {
          const blob = new Blob([res.data], { type: image.attributes.type })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = image.attributes.fileName
          link.click()
        }
      })
  }

  function renderDownload() {
    const url = image.attributes.url
    const className = 'message-attachment__icon-container message-attachment__icon-container--small'
    const icon = <Icon type={['fas', iconName]} className="message-attachment__icon" />

    if (url.includes('active_storage/blobs/')) {
      return (
        <span onClick={() => downloadBlob(url)} className={className}>
          {icon}
        </span>
      )
    }

    return (
      <a
        href={url}
        download={image.attributes.fileName}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
      >
        {icon}
      </a>
    )
  }

  return (
    <span className="message-attachment message-attachment--aligned is-trigger">
      <div
        className="message-attachment__icon-container message-attachment__icon-container--big"
        onClick={(e) => clickHandler(e)}
      >
        <Icon type={['fal', 'image']} className="message-attachment__icon" />
      </div>
      <div className="message-attachment__body" onClick={(e) => clickHandler(e)}>
        <p className="message-attachment__filename">{image.attributes.fileName}</p>
        <p className="message-attachment__filesize">Size {numeral(image.attributes.fileSize).format('0.0b')}</p>
      </div>
      {image.attributes.url && download
        ? renderDownload()
        : (
          <span
            className="message-attachment__icon-container message-attachment__icon-container--small"
            onClick={(e) => clickHandler(e)}
          >
            <Icon type={['fas', iconName]} className="message-attachment__icon" />
          </span>
        )}
    </span>
  )
}

MessageImage.propTypes = {
  image: shape({
    attributes: shape({
      url: string,
      fileSize: number.isRequired,
      fileName: string.isRequired,
    }).isRequired,
  }).isRequired,
  iconName: string,
  onImageClick: func.isRequired,
  download: bool,
  index: number.isRequired,
}

export default MessageImage
